import { ApiBase } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { SchedulerResponseEntity } from './scheduler-response-entity';
import { SchedulerCreateEntity } from './scheduler-create-entity';

@inject(IHttpClient)
export class SchedulerApi extends ApiBase {

    private _baseUrl: string = 'api/scheduler';

    constructor(http: IHttpClient) {
        super(http);
    }

    public async getById(id: string): Promise<SchedulerResponseEntity> {
        const response = await this.get(this._baseUrl + '/' + id);
        return SchedulerResponseEntity.fromDto(response.content);
    }
    public async create(entity: SchedulerCreateEntity): Promise<SchedulerResponseEntity> {
        const dto = entity.toDto();
        const response = await this.post(this._baseUrl, dto);
        return SchedulerResponseEntity.fromDto(response.content);
    }
}
